import React from 'react';
import styles from './FullTextsPreview.module.css';
import { Document } from 'types';
import { DocumentViewer } from 'components/shared';

export function FullTextsPreview({
  documents,
}: {
  documents: Document[];
}): JSX.Element | null {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className={styles.FullTextsPreview}>
      <div className={styles.preview}>
        <DocumentViewer documents={documents} />
      </div>
    </div>
  );
}
